import { render } from "./PopupStyle.vue?vue&type=template&id=13173666"
import script from "./PopupStyle.vue?vue&type=script&lang=js"
export * from "./PopupStyle.vue?vue&type=script&lang=js"

import "./PopupStyle.vue?vue&type=style&index=0&id=13173666&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__